<!-- HERO SECTION -->
<!-- HERO SECTION -->
<section class="relative bg-[#081426] text-white py-16 md:py-24 lg:py-28 overflow-hidden">

    <!-- Background Image -->
    <div class="absolute inset-0 z-0 overflow-hidden pointer-events-none">

        <img src="/assets/visidea/banner-eo.png" alt="Event Organizer Stage" class="
                w-full
                h-full
                object-cover
                object-center
                opacity-[0.82]
                scale-[1.00]
            ">

        <!--
            Overlay dibuat lebih ringan:
            - kiri tetap gelap supaya teks terbaca
            - kanan dibuat jauh lebih transparan
            - foto tidak lagi terlalu tertutup
        -->
        <div class="
                absolute
                inset-0
                bg-gradient-to-r
                from-[#071426]/95
                via-[#071426]/55
                to-[#071426]/10
            "></div>

        <!-- Soft bottom overlay -->
        <div class="
                absolute
                inset-0
                bg-gradient-to-t
                from-[#071426]/35
                via-transparent
                to-[#071426]/10
            "></div>

        <!-- Soft ambient glow -->
        <div class="
                absolute
                -top-40
                -left-28
                w-[420px]
                h-[420px]
                bg-cyan-500/10
                rounded-full
                blur-3xl
            "></div>

        <div class="
                absolute
                top-1/3
                right-0
                w-[420px]
                h-[420px]
                bg-teal-400/10
                rounded-full
                blur-3xl
            "></div>

    </div>


    <!-- Content -->
    <div class="
            max-w-7xl
            mx-auto
            px-4
            sm:px-6
            md:px-8
            relative
            z-10
        ">

        <div class="max-w-3xl space-y-6">

            <!-- Heading -->
            <h1 class="
                    text-4xl
                    sm:text-5xl
                    md:text-6xl
                    lg:text-7xl
                    font-extrabold
                    tracking-tight
                    manpower-hero-title
                    leading-tight
                ">
                <!-- man  -->
                Manpower

            </h1>


            <!-- Subtitle -->
            <p class="
                    text-slate-200
                    text-sm
                    sm:text-base
                    md:text-lg
                    leading-relaxed
                    max-w-2xl
                    font-light
                ">
                Dari konsep hingga eksekusi, kami hadir sebagai partner
                event Anda untuk mewujudkan acara yang berkesan,
                terorganisir, dan berjalan lancar dengan dukungan
                teknologi serta tim profesional.
            </p>


            <!-- Highlights -->
            <div class="
                    flex
                    flex-wrap
                    items-center
                    gap-3
                    sm:gap-6
                    pt-2
                ">

                <div class="
                        flex
                        items-center
                        gap-2
                        text-xs
                        sm:text-sm
                        text-slate-100
                        font-medium
                    ">
                    <span class="
                            w-5
                            h-5
                            rounded-full
                            bg-emerald-500/20
                            text-[#31E986]
                            flex
                            items-center
                            justify-center
                            font-bold
                            text-xs
                        ">
                        ✔
                    </span>

                    <span>
                        Integrated Event System
                    </span>
                </div>


                <div class="
                        flex
                        items-center
                        gap-2
                        text-xs
                        sm:text-sm
                        text-slate-100
                        font-medium
                    ">
                    <span class="
                            w-5
                            h-5
                            rounded-full
                            bg-emerald-500/20
                            text-[#31E986]
                            flex
                            items-center
                            justify-center
                            font-bold
                            text-xs
                        ">
                        ✔
                    </span>

                    <span>
                        Custom Event
                    </span>
                </div>


                <div class="
                        flex
                        items-center
                        gap-2
                        text-xs
                        sm:text-sm
                        text-slate-100
                        font-medium
                    ">
                    <span class="
                            w-5
                            h-5
                            rounded-full
                            bg-emerald-500/20
                            text-[#31E986]
                            flex
                            items-center
                            justify-center
                            font-bold
                            text-xs
                        ">
                        ✔
                    </span>

                    <span>
                        Professional Team
                    </span>
                </div>

            </div>

        </div>

    </div>

</section>

<!-- SECTION: PILIHAN MANPOWER & CTA (1 VIEWPORT) -->
<section class="manpower-section" aria-labelledby="manpower-title">
    <div class="manpower-container">
        <div class="manpower-heading">
            <h2 id="manpower-title">Pilihan Manpower untuk Event Anda</h2>
            <p>Pilih tenaga profesional yang sesuai dengan kebutuhan acara, mulai dari penyambutan tamu, promosi brand,
                hingga koordinasi operasional di lapangan.</p>
        </div>

        <div class="manpower-grid">
            <button type="button" class="manpower-card" *ngFor="let role of manpowerRoles"
                (click)="selectManpowerRole(role.id)">
                <img class="manpower-card__image" [src]="role.image" alt="" loading="lazy">
                <span class="manpower-card__name">{{ role.name }}</span>
                <span class="manpower-card__description">{{ role.description }}</span>
            </button>
        </div>

        <!-- COMPACT CTA BANNER (RAMPING & PAS DI BAWAH MANPOWER GRID) -->
        <div
            class="mt-7 md:mt-8 bg-[#102B51] rounded-2xl py-4 px-6 md:py-5 md:px-10 shadow-2xl relative overflow-hidden flex flex-col md:flex-row items-center justify-between gap-5">
            <!-- Decorative Glow Background -->
            <div
                class="absolute -right-16 -bottom-16 w-56 h-56 bg-emerald-500/20 rounded-full blur-2xl pointer-events-none">
            </div>
            <div
                class="absolute -left-16 -top-16 w-56 h-56 bg-blue-500/20 rounded-full blur-2xl pointer-events-none">
            </div>

            <!-- Left Text Content -->
            <div class="text-center md:text-left relative z-10">
                <h3 class="text-lg sm:text-xl md:text-2xl font-bold text-white tracking-tight">
                    Diskusikan Event Impian Anda Sekarang!
                </h3>
                <p class="text-xs sm:text-sm md:text-base text-slate-300 max-w-xl mt-1">
                    Tim kami siap membantu mewujudkan acara yang berkesan dan sesuai dengan kebutuhan Anda.
                </p>
            </div>

            <!-- Right WhatsApp Button -->
            <div class="relative z-10 flex-shrink-0">
                <button (click)="chatWhatsApp()"
                    class="inline-flex items-center gap-2.5 px-6 py-3 rounded-full bg-[#22C55E] hover:bg-[#16A34A] text-white font-bold text-sm md:text-base shadow-lg hover:shadow-emerald-500/40 hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer">
                    <img src="/assets/visidea/whatsapp.png" class="w-5 h-5 brightness-0 invert" alt="WhatsApp">
                    <span>Chat via WhatsApp</span>
                </button>
            </div>
        </div>
    </div>
</section>

<!-- DETAIL PACKAGE MODAL -->
<div *ngIf="selectedPackageForModal" class="fixed inset-0 z-50 overflow-y-auto">
    <!-- Backdrop Blur -->
    <div (click)="closeDetailModal()" class="fixed inset-0 bg-black/60 backdrop-blur-sm transition-opacity"></div>

    <div class="flex min-h-full items-center justify-center p-4 sm:p-6 text-center">
        <div
            class="relative w-full max-w-2xl transform overflow-hidden rounded-3xl bg-white text-left shadow-2xl transition-all border border-slate-100 animate-scale-up">

            <!-- Modal Header with Image Cover -->
            <div class="relative h-56 sm:h-64 overflow-hidden">
                <img [src]="selectedPackageForModal.image" [alt]="selectedPackageForModal.name"
                    class="w-full h-full object-cover">
                <div class="absolute inset-0 bg-gradient-to-t from-slate-950/90 via-slate-950/40 to-transparent"></div>

                <!-- Close Button -->
                <button (click)="closeDetailModal()"
                    class="absolute top-4 right-4 w-9 h-9 rounded-full bg-black/40 hover:bg-black/60 text-white flex items-center justify-center transition-all cursor-pointer z-10">
                    ✕
                </button>

                <!-- Badge & Title on Image -->
                <div class="absolute bottom-5 left-6 right-6 text-white space-y-1">
                    <span [ngClass]="selectedPackageForModal.badgeColor"
                        class="text-white text-[11px] font-bold px-3 py-1 rounded-full shadow-md uppercase">
                        {{ selectedPackageForModal.badge }}
                    </span>
                    <h3 class="text-2xl sm:text-3xl font-extrabold text-white mt-1">
                        {{ selectedPackageForModal.name }}
                    </h3>
                </div>
            </div>

            <!-- Modal Body Content -->
            <div class="p-6 sm:p-8 space-y-6 max-h-[60vh] overflow-y-auto">
                <!-- Pricing & Tagline -->
                <div class="flex items-baseline justify-between pb-4 border-b border-slate-100">
                    <div>
                        <span class="text-xs text-slate-400 block font-medium">Investasi Layanan</span>
                        <div class="flex items-baseline gap-2 mt-0.5">
                            <span class="text-2xl sm:text-3xl font-black text-[#102B51]">
                                {{ selectedPackageForModal.priceFormatted }}
                            </span>
                            <span *ngIf="selectedPackageForModal.originalPriceFormatted"
                                class="text-sm text-slate-400 line-through">
                                {{ selectedPackageForModal.originalPriceFormatted }}
                            </span>
                        </div>
                    </div>
                    <span class="text-xs font-bold text-teal-600 bg-teal-50 px-3 py-1.5 rounded-full uppercase">
                        {{ selectedPackageForModal.tag }}
                    </span>
                </div>

                <!-- Description -->
                <div class="space-y-2">
                    <h4 class="text-sm font-bold text-[#102B51] uppercase tracking-wider">Deskripsi Layanan</h4>
                    <p class="text-sm text-slate-600 leading-relaxed">
                        {{ selectedPackageForModal.description }}
                    </p>
                </div>

                <!-- Features & Deliverables Checklist -->
                <div class="space-y-3">
                    <h4 class="text-sm font-bold text-[#102B51] uppercase tracking-wider">Cakupan & Fasilitas Utama</h4>
                    <div class="grid grid-cols-1 sm:grid-cols-2 gap-2.5">
                        <div *ngFor="let feat of selectedPackageForModal.features"
                            class="flex items-start gap-2 text-xs sm:text-sm text-slate-700 bg-slate-50 p-2.5 rounded-xl border border-slate-100">
                            <span class="text-emerald-600 font-bold">✔</span>
                            <span class="font-medium">{{ feat }}</span>
                        </div>
                    </div>
                </div>

                <!-- Deliverables Breakdown -->
                <div *ngIf="selectedPackageForModal.deliverables?.length" class="space-y-3">
                    <h4 class="text-sm font-bold text-[#102B51] uppercase tracking-wider">Deliverables & Output</h4>
                    <div class="space-y-2">
                        <div *ngFor="let deliv of selectedPackageForModal.deliverables"
                            class="flex items-start gap-2.5 text-xs sm:text-sm text-slate-600">
                            <span class="w-1.5 h-1.5 rounded-full bg-blue-600 mt-2 flex-shrink-0"></span>
                            <span>{{ deliv }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Modal Footer Actions -->
            <div class="p-6 bg-slate-50 border-t border-slate-100 flex flex-col sm:flex-row items-center gap-3">
                <button (click)="chatWhatsApp(selectedPackageForModal)"
                    class="w-full sm:w-auto py-3 px-5 rounded-xl bg-emerald-50 hover:bg-emerald-100 text-emerald-700 font-bold text-xs sm:text-sm flex items-center justify-center gap-2 transition cursor-pointer">
                    <img src="/assets/visidea/whatsapp.png" class="w-4 h-4" alt="">
                    <span>Konsultasi via WhatsApp</span>
                </button>
                <div class="flex-1 w-full flex items-center gap-3">
                    <button (click)="addToCart(selectedPackageForModal)"
                        class="flex-1 py-3 px-4 rounded-xl border-2 border-[#102B51] text-[#102B51] hover:bg-[#102B51] hover:text-white font-bold text-xs sm:text-sm transition cursor-pointer">
                        + Keranjang
                    </button>
                    <button (click)="checkout(selectedPackageForModal)"
                        class="flex-1 py-3 px-4 rounded-xl bg-[#102B51] hover:bg-[#1B1E5B] text-white font-bold text-xs sm:text-sm transition shadow-md cursor-pointer">
                        Checkout Sekarang
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>